<mat-list>
    <eas-workflow-audit-issue-list-item *ngFor="let issue of issues; first as isFirst; last as isLast"
                                        [issue]="issue"
                                        [isLast]="isLast"
                                        [isFirst]="isFirst">
    </eas-workflow-audit-issue-list-item>
</mat-list>